
<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <add-new-location
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
    />
    <div class="flex items-center flex-grow justify-between">
      <div class="flex items-center">
        <!-- ADD NEW -->
        <div
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="addNewDataSidebar = true"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Add New Location</span>
        </div>
      </div>
      <div>
        <vs-input
          placeholder="Search"
          v-model="searchQuery"
          class="w-full input-rounded-full no-icon-border mb-4 mr-6"
          icon="icon-search"
          icon-pack="feather"
        />
      </div>
    </div>
    <div class="vx-row">
      <div
        v-if="filteredList.length == 0"
        class="vx-col sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/6 mx-auto text-center p-6 m-8"
      >
        <vx-card class="shadow-md">
          <h5>No data Available</h5>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base"
        :key="indextr"
        v-for="(item, indextr) in filteredList"
      >
        <vx-card class="shadow-md">
          <div class="my-6">
            <h2 class="mb-6 text-center">{{ item.name }}</h2>
            <p class="text-lg">Inside Zone: {{ item.locationZoneName }}</p>
            <p class="text-lg">Address: {{item.address}}</p>
          </div>
          <vs-divider></vs-divider>
          <div class="flex justify-between flex-wrap">
            <vs-button
              class="m-2"
              color="success"
              icon-pack="feather"
              icon="icon-refresh-cw"
              type="gradient"
              @click="updateLocationPopup(item)"
              icon-after
            >Update</vs-button>
            <vs-button
              class="m-2"
              type="gradient"
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              icon-after
              @click="deleteLocation(item)"
            >Delete</vs-button>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="locations">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewDataSidebar = true"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New Location</span>
          </div>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ locations.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : locations.length }} of {{ locations.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="locationName">Location Name</vs-th>
        <vs-th sort-key="address">Addres</vs-th>
        <vs-th sort-key="locationZoneName">Inside Zone</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md">
            <vs-td class="img-container">
              <img :src="require(`@/assets/images/Google-map.png`)" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.address }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{tr.locationZoneName}}</p>
            </vs-td>

            <vs-td>
              <div class="flex justify-start">
                <vs-button
                  class="m-2"
                  color="success"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  type="gradient"
                  @click="updateLocationPopup(tr)"
                  icon-after
                >Update</vs-button>
                <vs-button
                  class="m-2"
                  type="gradient"
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  icon-after
                  @click="deleteLocation(tr)"
                >Delete</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>-->
    <!-- popup code -->
    <vs-popup classContent="popup-example" title="Update Location" :active.sync="popupActive">
      <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
        <div class="p-6">
          <div class="mt-1">
            <gmap-map
              :center="coordinates"
              :zoom="zoom"
              map-type-id="terrain"
              style="min-width: 200px; min-height: 400px;width:100%"
            >
              <gmap-marker
                :position="coordinates"
                :clickable="true"
                :draggable="true"
                @click="center=latLng"
              ></gmap-marker>
            </gmap-map>
          </div>
          <gmap-autocomplete
            class="vs-inputx vs-input--input normal"
            style="width: 100%;border: 1px solid rgba(0, 0, 0, 0.2);margin-top: 1.25rem !important;"
            :placeholder="placeholder"
            :value="address"
            @place_changed="setPlace"
            :select-first-on-enter="true"
          ></gmap-autocomplete>
          <vs-input
            label="Location Name"
            v-validate="'required|regex:^[a-zA-Z0-9 ]*$|min:3|max:24'"
            data-vv-validate-on="blur"
            name="Name"
            v-model="name"
            class="mt-5 w-full"
          />
          <span class="text-danger text-sm">{{ errors.first('Name') }}</span>

          <!-- CATEGORY -->
          <vs-select autocomplete label="Select Zone" class="mt-5 w-full" v-model="selectedZone">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in availableZones"
            />
          </vs-select>
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center justify-center p-6">
        <vs-button class="mr-6" :disabled="!validateForm" @click="updateLocation">Update</vs-button>
        <vs-button type="border" color="danger" @click="closePopup">Cancel</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import AddNewLocation from "./AddNewLocation.vue";
import firebase, { functions } from "firebase/app";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  components: {
    AddNewLocation,
    VuePerfectScrollbar
  },
  data() {
    return {
      locations: [],
      itemsPerPage: 5,
      isMounted: false,
      popupActive: false,
      addNewDataSidebar: false,
      currentSelectedLocationId: "",
      name: "",
      availableZones: [],
      selectedZone: "",
      address: "",
      searchQuery: "",
      placeholder: "Enter Location Address",
      endpoint: this.$store.state.endpoint2,
      latLng: { lat: 22.572646, lng: 88.36389499999996 },
      center: { lat: 22.572646, lng: 88.36389499999996 },
      coordinates: {
        lat: 22.572646,
        lng: 88.36389499999996
      },
      zoom: 15,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    filteredList() {
      return this.locations.filter(location => {
        if (
          location.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        ) {
          return true;
        }
        if (
          location.address
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        ) {
          return true;
        }
        if (
          location.locationZoneName
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        ) {
          return true;
        }
      });
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    validateForm() {
      return !this.errors.any() && this.name != "" && this.address != "";
    }
  },
  methods: {
    updateLocationPopup(data) {
      this.name = data.name;
      this.address = data.address;
      this.coordinates = data.coordinates;
      this.selectedZone = data.locationZone;
      this.currentSelectedLocationId = data.id;
      this.popupActive = true;
    },
    updateLocation() {
      var docId = this.currentSelectedLocationId;
      var payload = {
        id: docId,
        name: this.name,
        address: this.address,
        clientId: this.$store.state.userInfo.id,
        coordinates: this.coordinates,
        locationZone: this.selectedZone
      };
      this.$http
        .post(this.endpoint + "/updatelocation", payload)
        .then(response => {
          this.popupActive = false;
          this.initValues();
          this.$vs.notify({
            title: "Location Updated",
            text: "Your location is successfully Updated!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
          const payload = {
            clientId: this.$store.state.userInfo.id,
            notify: this.$vs.notify
          };
          this.$store.dispatch("getLocationData", payload);
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: error.response.data,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    initValues() {
      var selectedZoneDefault = this.$store.state.zones[0].name;
      this.name = "";
      this.selectedZone = selectedZoneDefault;
      this.address = "";
      this.coordinates = {
        lat: 22.572646,
        lng: 88.36389499999996
      };
    },
    closePopup() {
      this.popupActive = false;
      this.initValues();
    },
    setPlace(place) {
      this.address = place.formatted_address;

      this.coordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
    },
    deleteLocation(data) {
      var itemObj = data.id;
      this.$http
        .get(this.endpoint + "/deletelocation?id=" + itemObj)
        .then(response => {
          const payload = {
            clientId: this.$store.state.userInfo.id,
            notify: this.$vs.notify
          };
          this.$store.dispatch("getLocationData", payload);
          this.$vs.notify({
            title: "Location Deleted",
            text: "Your location is successfully deleted!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: error.response.data,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  },
  created() {
    const payload = {
      clientId: this.$store.state.userInfo.id,
      notify: this.$vs.notify
    };
    this.$store.dispatch("getLocationData", payload);
    this.$store.watch(
      state => {
        return this.$store.state.locations; // could also put a Getter here
      },
      (newValue, oldValue) => {
        //something changed do something
        var res = newValue;
        var zoneData = this.$store.state.zones;
        function getZoneName(zoneId) {
          for (var m in zoneData) {
            if (zoneData[m].id == zoneId) {
              return zoneData[m].name;
            }
          }
        }
        for (var o in res) {
          res[o].locationZoneName = getZoneName(res[o].locationZone);
        }
        this.locations = res;
      }
    );
  },
  mounted() {
    this.isMounted = true;
    var data = this.$store.state.zones;
    var zones = [];
    var sortedData = data.sort(function(a, b) {
      var nameA = a.name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    console.log(sortedData);
    for (var x in sortedData) {
      zones.push({ text: sortedData[x].name, value: sortedData[x].id });
    }
    this.availableZones = zones;
    this.selectedZone = zones[0].value;
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style>
.pac-container {
  z-index: 53000 !important;
}
</style>